<template>
  <div>
    <yd-cell-group v-show="searchDiv">
      <yd-cell-item>
        <yd-icon slot="icon" name="phone3" size=".45rem"></yd-icon>
        <input type="text" slot="right" v-model="phone" placeholder="请输入手机号码">
      </yd-cell-item>
      <yd-cell-item v-show="codeOpen">
        <yd-icon slot="icon" name="verifycode" size=".45rem"></yd-icon>
        <input type="text" slot="right" v-model="code" placeholder="请输入验证码">
        <yd-sendcode slot="right"
                     v-model="codeStatus"
                     storage-key="hahaha"
                     @click.native="sendCode"
                     type="warning"
        ></yd-sendcode>
      </yd-cell-item>
      <yd-button size="large" type="primary" @click.native="codeSearch" v-preventReClick>提交</yd-button>
    </yd-cell-group>
    <ul class="voucher">
      <li v-for="(item, key) in codeList" :key="key">
        <!-- <div><span>{{item.code}}</span><span class="right">{{item.is_qiandao}}</span></div> -->
        <div v-if="item.contacts.length > 0">
          <img :src="item.code_img">
          <p>{{item.contacts[0].user_name}}</p>
          <p>{{item.contacts[0].company}}</p>
          <div class="dibu">
            <span>{{item.is_qiandao}}</span>
            <a :href="item.url">查看详情</a>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script type="text/babel">
import axios from 'axios'
export default {
  data () {
    return {
      params: this.$route.params,
      phone: '',
      searchDiv: true,
      code: '',
      codeOpen: false,
      codeStatus: false,
      codeList: []
    }
  },
  methods: {
    sendCode () {
      let res = this.checkFormat('phone')
      if (!res) {
        return false
      }
      this.$dialog.loading.open('发送中...')
      let data = {
        mobile: this.phone,
        type: 1,
        fair_id: this.params.id
      }
      axios
        .post('/user/send-sms', data)
        .then(this.sendSmsScc)
    },
    sendSmsScc (res) {
      res = res.data
      if (res.status) {
        this.codeStatus = true
        this.$dialog.loading.close()
        this.$dialog.toast({
          mes: '已发送'
        })
      } else {
        this.$dialog.loading.close()
        this.$dialog.toast({
          mes: res.msg
        })
      }
    },
    checkFormat (res) {
      if (res === 'phone') {
        if (this.phone === undefined || this.phone.length !== 11) {
          this.$dialog.toast({
            mes: '请填写正确的手机号'
          })
          return false
        }
      } else if (res === 'code' && this.codeOpen === true) {
        if (this.phone === undefined || this.phone.length !== 11) {
          this.$dialog.toast({
            mes: '请填写正确的手机号'
          })
          return false
        }
        if (this.code.length <= 0) {
          this.$dialog.toast({
            mes: '请填写验证码'
          })
          return false
        }
      }
      return true
    },
    codeSearch () {
      let res = this.checkFormat('code')
      if (!res) {
        return false
      }
      let data = {}
      if (this.codeOpen === false) {
        data = {fair_id: this.params.id, mobile: this.phone}
      } else {
        data = {fair_id: this.params.id, mobile: this.phone, code: this.code}
      }

      axios
        .post('/fair/search-ticket', data)
        .then(this.codeSearchSucc)
    },
    codeSearchSucc (res) {
      res = res.data
      if (res.status) {
        this.codeList = res.data
        this.searchDiv = false
        this.$dialog.toast({
          mes: '查询成功'
        })
      } else {
        this.$dialog.toast({
          mes: res.msg
        })
      }
      console.log(res)
    },
    HistoryBack () {
      window.history.back()
    },
    getSetting () {
      let data = {fairid: this.params.id, type_: 'qiandaoma_close'}
      axios
        .post('/user/setting', data)
        .then(res => {
          res = res.data
          if (res.res === '1') {
            this.codeOpen = true
          }
        })
    }
  },
  mounted () {
    this.getSetting()
  }
}
</script>

<style lang="stylus" scoped>
  @css{
    .voucher{
      overflow:hidden;
      margin:0 0.2rem;
    }
    .voucher li{
      overflow:hidden;
      background:#fff;
      margin-bottom:0.4rem;
    }
    .voucher li div{
      padding:0.2rem 0.3rem;
      overflow:hidden;
      font-size:0.32rem;
      color:#666;
    }
    .voucher li div .right{
      float:right;
    }
    .voucher li  img{
      display:block;
      width:77%;
      margin:0.2rem auto;
    }
    .voucher li p{
      padding:0 0.3rem;
      font-size:0.32rem;
      color:#666;
      text-align: center;
    }
    .voucher li a{
      display:block;
      color:#7f8185;
      font-size:0.3rem;
    }
    div.dibu{
      width: 100%;
      overflow: hidden;
    }
    div.dibu a{
      float:right;
      text-align: right;
      line-height: 1;
    }
    div.dibu span{
      float: left;
      text-align: left;
      line-height: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/template1/SingleCode.vue